export default {
  title: {
    fontFamily: 'heading',
    lineHeight: 'heading',
    textTransform: 'uppercase',
    fontWeight: '400',
    letterSpacing: '0px',
    textAlign: 'inherit'
  },
  subtitle: {
    fontFamily: 'heading',
    lineHeight: 'heading',
    textTransform: 'uppercase',
    color: 'primary',
    border: 'none',
    fontWeight: '600',
    fontFamily: 'heading',
    textAlign: 'inherit'
  },
  text: {
    color: 'text2',
    lineHeight: 'body',
    fontFamily: 'body',
    fontWeight: 'body',
    lineHeight: '1.75',
    textAlign: 'inherit',
    mb: '1.5rem',
    '*': {
      color: 'inherit',
      textAlign: 'inherit'
    }
  },
  navLink: { fontFamily: 'heading' },
  link: {
    textDecoration: 'none',
    color: 'unset'
  }
}
